import { Component, OnInit } from '@angular/core';

import {MoreService} from '../../service/more.service';
import {Router} from '@angular/router';
import { Ademas } from '../../models/ademas';

@Component({
  selector: 'app-ademas',
  templateUrl: './ademas.component.html',
  styleUrls: ['./ademas.component.css']
})
export class AdemasComponent implements OnInit {
  mores: Array<Ademas> = new Array<Ademas>();

  constructor(private dataservice: MoreService, private Ruta: Router) { }

  ngOnInit(): void {
    this.dataservice.getMore().subscribe(resp => {
      for (const data of resp.body) {
        this.mores.push(data);
      }
    });
  }

  irDetalleMore(more: Ademas) {
    this.dataservice.more = more;
    this.Ruta.navigateByUrl('/detail-more/' + this.dataservice.more.tituloProyectoAdemas);
  }
}
